import { cn } from "./cn";

const SectionCard = ({ children, className, id }) => (
  <div
    id={id}
    className={cn(
      "rounded bg-white shadow-[1px_6px_30px_rgba(0,31,14,0.05)]",
      className,
    )}
  >
    {children}
  </div>
);

export default SectionCard;
